const mutations = {
  onGet (state, payload) {
    if(payload.event.isSelectOperator === true) payload.event.context.usersOperators = payload.response.data.data.data

    else payload.event.context.users = payload.response.data.data.data
    payload.event.context.optionsDataTable.total = payload.response.data.data.total
    payload.event.context.loadTable = false
    payload.event.context.loadingTabs = false
  },
  onGetAll (state, payload) {
    payload.event.context.users = payload.response.data.data.data
  },
  onGetById (state, payload) {
    payload.event.context.editedItem = payload.response.data.data
    payload.event.context.editedItem.password = ''
    payload.event.context.editedItem.company_id = payload.event.context.editedItem.companies.length > 0 ? payload.event.context.editedItem.companies[0].id : 1
    if (payload.event.context.editedItem.license_number === null) payload.event.context.editedItem.license_number = ''
    if (payload.event.context.editedItem.phone === null) payload.event.context.editedItem.phone = ''
    if (payload.event.context.editedItem.last_name === null) payload.event.context.editedItem.last_name = ''
    payload.event.context.editedIndex = payload.response.data.data.id
    payload.event.context.loadItem = false
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.closeForm()
    payload.event.context.getByTag()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.closeForm()
    payload.event.context.getByTag()
  },
  onUpdateOwn (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.closeUser()
    payload.event.context.getUserLogged()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.getByTag()
    payload.event.context.close()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingBtn = false
  },
  onGetInspect (state, payload) {
    payload.event.context.users = payload.response.data.data
    payload.event.context.loadTable = false
  },
  onPostOperatorAndInspector (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loadingBtn = false
    payload.event.context.closeSendModal()
    payload.event.context.getByTag()
  }
}

export default mutations